/*
 * patient-form (zod)
 */
import { createInsertSchema, createSelectSchema } from "drizzle-zod"
import * as z from "zod"
import { globalCreateExclude, globalUpdateExclude } from "../utils/constants"
import { patientForms } from "./patient-form.schema"

export const PATIENT_FORM_STATUSES = ["assigned", "in_progress", "completed"] as const
export type PatientFormStatus = (typeof PATIENT_FORM_STATUSES)[number]

/* Select */
export type PatientForm = z.infer<typeof selectPatientFormSchema>
export const selectPatientFormSchema = createSelectSchema(patientForms)

/* Filters */
export type PatientFormFilters = z.infer<typeof patientFormFiltersSchema>
export const patientFormFiltersSchema = z.object({
	id: z.string().optional(),
	patientId: z.string().optional(),
	formId: z.string().optional(),
	status: z.enum(PATIENT_FORM_STATUSES).optional(),
	active: z.boolean().optional(),
})

/* Create */
export const createPatientFormSchema = createInsertSchema(patientForms, {
	patientId: z.string().uuid(),
	formId: z.string().uuid(),
	status: z.enum(PATIENT_FORM_STATUSES).optional(),
}).partial(globalCreateExclude)
export type CreatePatientForm = z.infer<typeof createPatientFormSchema>

/* Update */
export const updatePatientFormSchema = createInsertSchema(patientForms)
	.omit(globalUpdateExclude)
	.partial()
	.required({ id: true })
export type UpdatePatientForm = z.infer<typeof updatePatientFormSchema>
